import React from 'react';
import Modal from '../../../../react-component/modal';

import { Text, TextInputNative, ErrorText, ErrorContainer } from '../styles';

export const EditarUsuarioModal = ({
    visible,
    onSave,
    onClose,
    editedEmail,
    setEditedEmail,
    editedCpfCnpj,
    editErrorMessage,
    isLoading
}) => {
    if (!visible) return null;

    return (
        <Modal
            title="Editar usuário"
            saveText="Salvar"
            onSave={onSave}
            onClose={onClose}
            isSaveButtonLoading={isLoading}
        >
            <Text>Email</Text>
            <TextInputNative
                style={{ marginTop: 4 }}
                value={editedEmail}
                onChange={(e) => setEditedEmail(e.target.value)}
            />
            {editErrorMessage && (
                <ErrorContainer>
                    <ErrorText>{editErrorMessage}</ErrorText>
                </ErrorContainer>
            )}
            <Text style={{ marginTop: 24 }}>CPF/CNPJ</Text>
            <TextInputNative
                style={{ marginTop: 4 }}
                value={editedCpfCnpj}
                placeholder="Usuário não concluiu o cadastro"
                disabled
            />
        </Modal>
    );
};
